import type { HTMLAttributes } from 'react';
import styles from './FilterTabs.module.css';

export interface FilterTabItem {
  label: string;
  value: string;
  /** Conteo a mostrar en el badge. Sin valor, no se renderiza. */
  count?: number;
}

export interface FilterTabsProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  tabs: FilterTabItem[];
  activeTab: string;
  onTabChange: (value: string) => void;
  className?: string;
}

/**
 * Pestañas de filtrado rápido con conteo opcional por pestaña.
 * El conteo es un dato de presentación: no cambia con los filtros aplicados.
 */
export function FilterTabs({ tabs, activeTab, onTabChange, className, ...props }: FilterTabsProps) {
  const classes = [styles.tabList, className].filter(Boolean).join(' ');

  return (
    <div className={classes} role="tablist" aria-label="Filtros por estado" {...props}>
      {tabs.map((tab) => {
        const isActive = tab.value === activeTab;

        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={[styles.tab, isActive && styles.active].filter(Boolean).join(' ')}
            onClick={() => onTabChange(tab.value)}
          >
            <span className={styles.label}>{tab.label}</span>
            {tab.count != null && <span className={styles.count}>{tab.count}</span>}
          </button>
        );
      })}
    </div>
  );
}

FilterTabs.displayName = 'FilterTabs';
